import { ButtonGroup, Button, createStandaloneToast } from '@chakra-ui/react';
import queries from '../../../utils/query';
import { useMutation } from '@apollo/client';

function toastCreateSuccess({ isCanvasPage, projectInfo }) {
	return {
		title: `Projeto ${isCanvasPage ? 'Editado' : 'Criado'} com sucesso!`,
		description: `Projeto '${projectInfo.viewName}' ${isCanvasPage ? 'editado' : 'criado'} com sucesso!`,
		status: 'success',
		duration: 3000,
		isClosable: true,
		position: 'top',
	};
}

function toastCreateError({ isCanvasPage }) {
	return {
		title: `Projeto não foi ${isCanvasPage ? 'editado' : 'criado'}!`,
		description: `Houve um erro com a requisição, por favor, tente novamente`,
		status: 'error',
		duration: 3000,
		isClosable: true,
		position: 'top',
	};
}

function createOrUpdateProject({
	setAccountNameValid,
	onClose,
	setSquadValid,
	isCanvasPage,
	toastCreateSuccess,
	toastCreateError,
	projectInfo,
	viewList,
	setViewList,
	setProjectData,
	setIsOpen,
	toast,
	createOrUpdateProjectMutation,
}) {
	if (!projectInfo.squad) {
		setSquadValid(false);
		return;
	}
	if (!projectInfo.accountName) {
		setAccountNameValid(false);
		return;
	}
	createOrUpdateProjectMutation({ variables: projectInfo })
		.then((result) => {
			if (!isCanvasPage) {
				const viewId = result.data.createViewListItem.id;
				const newProjectInfo = { ...projectInfo };
				newProjectInfo.viewId = viewId;
				newProjectInfo.createdAt = new Date();
				const newViewList = [...viewList];
				newViewList.unshift(newProjectInfo);
				setViewList(newViewList);
			} else if (setProjectData) {
				setProjectData({ ...projectInfo });
			}
			onClose();
			toast(toastCreateSuccess({ isCanvasPage, projectInfo }));
		})
		.catch((e) => {
			console.log(e);
			toast(toastCreateError({ isCanvasPage }));
		});
}

const CreateSaveProjectBtnGroup = ({
	setAccountNameValid,
	setProjectData,
	onClose,
	setSquadValid,
	projectInfo,
	isCanvasPage,
	setViewList,
	viewList,
}) => {
	const [createOrUpdateProjectMutation] = useMutation(queries.CREATE_OR_UPDATE_VIEW_LIST_ITEM);
	const toast = createStandaloneToast();

	return (
		<ButtonGroup d="flex" justifyContent="flex-end">
			<Button px={3} py={3} h="32px" variant="outline" onClick={onClose}>
				Cancelar
			</Button>
			<Button
				onClick={(e) =>
					createOrUpdateProject({
						setAccountNameValid,
						setSquadValid,
						isCanvasPage,
						toastCreateSuccess,
						toastCreateError,
						projectInfo,
						viewList,
						setViewList,
						setProjectData,
						onClose,
						toast,
						createOrUpdateProjectMutation,
					})
				}
				px={3}
				py={3}
				h="32px"
				bg="yellow.500"
				color="white"
			>
				Salvar
			</Button>
		</ButtonGroup>
	);
};

export default CreateSaveProjectBtnGroup;
